export default __webpack_public_path__ + "static/media/pytha.c0f40524.jfif";